import { Box, Button, Modal } from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./CommonPopups.module.css";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "95%",
    sm: "50%",
    lg: 408,
    xl: 408,
    md: 408,
  },
  bgcolor: "background.paper",
  border: "none",
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
  p: 3,
};

function ViewImagePopup(props: any) {
  const { onClose, image, type } = props;
  const [open, setOpen] = useState<boolean>(false);
  return (
    <div>
      <Button
        variant={"outlined"}
        sx={{
          textTransform: "capitalize",
          fontSize: "12px",
          fontWeight: "400",
        }}
        onClick={() => {
          setOpen(true);
        }}
      >
        View
      </Button>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: "99999999" }}
      >
        <Box sx={style}>
          <div>
            <div
              onClick={() => {
                setOpen(false);
              }}
              className={styles.closeModalButton}
            >
              <CloseIcon />
            </div>
            {image && (
              <div
                className={styles.modalViewImage}
                style={{ borderRadius: type !== "image" ? "50%" : "0%" }}
              >
                <img src={image} alt="img" />
              </div>
            )}
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default ViewImagePopup;
